// @flow

import * as React from 'react';
import { InteractionLogger } from '@ta/tracking.interactions';
import { Linkify } from '@ta/social.links';
import { LinkPreview } from '@ta/social.link-preview';
import { MemberEventOnObjectBlock } from '@ta/social.member-event';

import { CardSection, type Sponsorship } from '@ta/social.section-core';
import styles from './LinkPostSection.less';

export type LinkPostSectionProps = {
  member: any,
  actor: any,
  post: any,
  deleteObject: ?() => void,
  untagObject: ?() => void,
  loggedInUserId: string,
  isSingleObject: boolean,
  isEmbedded: boolean,
  clusterId?: string,
  sponsorship?: Sponsorship,
  socialStatisticsBar?: React.Node,
  socialActionBar?: React.Node,
};

const LinkPostSection = ({
  post,
  isSingleObject,
  isEmbedded,
  member,
  actor,
  deleteObject,
  untagObject,
  loggedInUserId,
  clusterId,
  sponsorship,
  socialStatisticsBar,
  socialActionBar,
}: LinkPostSectionProps) => {
  const linkPreview = {
    id: post.object.preview.id,
    title: post.object.preview.title,
    description: post.object.preview.description,
    url: post.object.preview.canonicalUrl,
    urlDomain: post.object.preview.urlDomain,
    imgSource:
      post.object.preview.media && post.object.preview.media[0]
        ? post.object.preview.media[0].photoSizes
        : undefined,
  };

  if (!post || !post.object) {
    return null;
  }

  const header = (
    <React.Fragment>
      <MemberEventOnObjectBlock
        objectEventType="onLinkPost"
        object={post.object}
        member={member}
        actor={actor}
        deleteObject={deleteObject}
        untagObject={untagObject}
        loggedInUserId={loggedInUserId}
        isEmbedded={isEmbedded}
      />

      {post.object.comment && post.object.comment.length && (
        <div key={`comment_${post.object.postId}`} className={styles.comment}>
          <Linkify text={post.object.comment} socialReferences={post.object.socialReferences} />
        </div>
      )}
    </React.Fragment>
  );

  const content = [
    <CardSection.Content key={`LinkPost_${post.object.postId}`} fullWidth>
      <InteractionLogger>
        {logFeedClick => (
          <LinkPreview
            linkPreviewState={linkPreview}
            isClickable
            onClick={e => logFeedClick(e, 'feedClick')}
            /** Add delineation for reposts */
            delineateContent={isEmbedded}
            tightenContent={
              post?.object?.tags?.orderedLocations?.length ? 'tighten_bottom' : 'tighten'
            }
            border={false}
          />
        )}
      </InteractionLogger>
    </CardSection.Content>,
  ];

  return (
    <CardSection
      isSingleObject={isSingleObject}
      header={header}
      content={content}
      socialStatisticsBar={socialStatisticsBar}
      socialActionBar={socialActionBar}
      pois={post.object.tags ? post.object.tags.orderedLocations : []}
      clusterId={clusterId}
      sponsorship={sponsorship}
    />
  );
};

LinkPostSection.defaultProps = {
  isSingleObject: false,
  isEmbedded: false,
  member: null,
  actor: null,
  deleteObject: null,
  untagObject: null,
  loggedInUserId: '',
  clusterId: undefined,
};

export default LinkPostSection;
